/**
 * Network-aware Solana explorer URL builder — public/shared.
 * Never fabricates URLs from placeholder signatures.
 */
export function buildSolscanUrl(kind, id, network = "MAINNET") {
  if (!id || typeof id !== "string") return null;
  const net = String(network || "MAINNET").toUpperCase();
  // Solscan supports mainnet-beta by default; explicit ?cluster= for devnet.
  const base = "https://solscan.io";
  const cluster = net === "DEVNET" ? "?cluster=devnet" : "";
  if (kind === "tx")      return `${base}/tx/${id}${cluster}`;
  if (kind === "address") return `${base}/account/${id}${cluster}`;
  if (kind === "token")   return `${base}/token/${id}${cluster}`;
  return null;
}
